import { Box, CircularProgress } from '@mui/material';
import { BackgroundStyle, SearchingBoxContainer, LongBlueButton, HeadingTitle } from "../../assets/style";
import { reportIcon } from '../../assets/imgs';
import { useEffect, useState } from "react";
import MainContent from '../../components/MainContent';
import { summaryPageName } from "../../components/PageName";
import { useLazyGetMaintenanceListByIdQuery , useUpdateMaintenanceMutation } from "../../features/maintenance/MaintenanceSlice";
import RecordTableV2, { TableRow, TableHeader } from "../../components/RecordTableV2";
import { RecordModel } from "../../models/RecordModel";
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { logOut } from '../../features/auth/authSlice';
import MaintenanceRecordModal from '../../components/MaintenanceRecordModal';
import MaintenanceRecordDetailDialog from '../../components/MaintenanceRecordDetailDialog';

const MaintenanceRecord = () => {
    const location = useLocation();
    const { id, stationName } = location.state;
    const [getMaintenanceList] = useLazyGetMaintenanceListByIdQuery();
    const [setMaintenanceDetail] = useUpdateMaintenanceMutation();
    const [tableRows, setTableRows] = useState<any[]>([]);
    const [data, setData] = useState<RecordModel<any>>();
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState<number>(0);
    const [modalOpen, setModalOpen] = useState(false);
    const [isLoading, setLoading] = useState<boolean>(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {t} = useTranslation();


    const columns: TableHeader[] = [
        { field: 'title', headerName: t("Title"), width: 300, isSortable: false },
        { field: 'maintenanceDate', headerName: t("Maintenance Date"), width: 200, isSortable: false },
        {
            field: "Detail",
            headerName: t("Detail"),
            width: 150,
            renderCell: (params: any) => (
                <img onClick={()=>handleDetailClick(params)} src={reportIcon} alt='logo'/>
            )
        },
    ];

    const fetchDataForPage = async (pageNumber: any) => {
        // Fetch data for the specified page from the backend
        const data = await getMaintenanceList({
            id:id,
            page: pageNumber,
            args:{ sortDirection:'desc' },
        });
        if (data.status === 'fulfilled') {
            return data.data.records.map((item: any) => ({
                id: item?.id,
                title: item?.title,
                maintenanceDate: new Date(item?.maintenanceDate).toLocaleString('en-US'),
            }))
        }

        if (data.status === 'rejected') {
            alert(t('An error occurred. Please login again.'));
            dispatch(logOut());
            navigate('/');
        }
    };

    const handleCreateClick = () => {
       setModalOpen(true);
    }

    const handleDetailClick = (rowData: TableRow) => {
        // console.log("Button clicked for row:", rowData);
        // Add your custom logic here
    };

    const handleSubmit = async (data: { staff:string, title:string, description:string, maintenanceFromDate: string, maintenanceToDate: string, attachments: File[] }) => {
        // Handle form submission here
        const form = new FormData();
        form.append('staff', data.staff);
        form.append('stationId', id);
        form.append('title', data.title);
        form.append('description', data.description);
        form.append('maintenanceDate', data.maintenanceFromDate);
        form.append('maintenanceDateTo', data.maintenanceToDate);
        data.attachments.forEach((element) =>  form.append('newAttachments', element));

        setMaintenanceDetail(form)
            .then((respone) => {
                if ('error' in respone) {
                    //console.log(respone.error);
                    alert("StatusCode: 400")
                }
                else {
                    //console.log(respone?.data);
                    setTimeout(() => {
                        window.location.reload();
                      }, 1000);
                    alert("Update Success")
                }
            })
      };

    useEffect(() => {
    }, [data])

    useEffect(() => {
        try {
            setLoading(true);
            getMaintenanceList({
                id: id,
                page: 1,
                args:{ sortDirection:'desc' },
            }).then(
                (res) => {
                    if (res.status === 'fulfilled') {
                        setLoading(false);
                        const tableRows = res?.data.records.map((item: any) => ({
                            id: item?.id,
                            title: item?.title,
                            maintenanceDate: new Date(item?.maintenanceDate).toLocaleString('en-US'),
                        }))
                        setTableRows(tableRows)
                        setData(res?.data)
                    }
                }
            )
        } catch (error) {

        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps


    const handleRowClick = (row : any) => {
        setSelectedRecord(row.id)
        setOpenDialog(true);
    };

    return (
        <MainContent type={summaryPageName}>
            <Box sx={{ bgcolor: '#456296' }}>
                <HeadingTitle>{t("Maintenance Record")}</HeadingTitle>
            </Box>
            <BackgroundStyle sx={{ zIndex: 0 }}>

                <MaintenanceRecordModal
                    additionalData={{stationName:stationName}}
                    open={modalOpen}
                    onClose={() => setModalOpen(false)}
                    onSubmit={handleSubmit}
                />
                <MaintenanceRecordDetailDialog
                    open={openDialog}
                    onClose={() => setOpenDialog(false)}
                    maintenanceId={selectedRecord}
                />
                    <SearchingBoxContainer>
                    </SearchingBoxContainer>
                    <LongBlueButton onClick={handleCreateClick}>{t("Create")}</LongBlueButton>
                {isLoading && <Box sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: 300
                }}>
                    <CircularProgress size={60} />
                </Box>}
                {!isLoading && <RecordTableV2
                    columns={columns}
                    rows={tableRows}
                    checkbox={false}
                    pages={data?.totalPages}
                    totalCount={data?.totalCount}
                    onClick={handleRowClick}
                    updateTableRows={setTableRows}
                    fetchDataForPage={fetchDataForPage}
                ></RecordTableV2>
                }
            </BackgroundStyle>
        </MainContent >
    );
};
export default MaintenanceRecord;